export const BusinessCustomerSlug = 'gewerbekunden';

export function getBusinessCustomerUrl(dealerSlug: string): string {
    return `/${dealerSlug}/${BusinessCustomerSlug}`;
}
